import Button from '@cashew/button';
import { useEnterListener } from '@cashew/hooks';
import Input from '@cashew/input';
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import './index.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import SelectComponent from '../../../components/SelectComponent';
import useQuery from '../../../hooks/useQuery';
import ExportModal from './ExportModal';
import {
  getFormattedOrderStatus,
  processOrderStatus,
} from './orders.functions';

const { api } = require('@cashew/utils');

const searchByData = [
  {
    key: 'orderId',
    value: 'Order ID',
  },
  {
    key: 'reference',
    value: 'Merchant order code',
  },
  {
    key: 'phoneNumber',
    value: 'Phone number',
  },
  {
    key: 'email',
    value: 'Email',
  },
  {
    key: 'nationalId',
    value: 'National ID',
  },
  {
    key: 'merchantName',
    value: 'Merchant Name',
  },
  {
    key: 'merchantId',
    value: 'Merchant ID',
  },
];

const filterStatusDataArray = [
  {
    key: 'ALL',
    value: 'All',
  },
  {
    key: 'REJECTED',
    value: 'Rejected',
  },
  {
    key: 'APPROVED',
    value: 'Approved',
  },
  {
    key: 'DISBURSED',
    value: 'Disbursed',
  },
  {
    key: 'RECEIVED',
    value: 'Received',
  },
];
export default ({
  setLoading,
  useSelector,
  setRecords,
  setList,
  pageSize,
  pageNumber,
  history,
  dispatch,
  records,
  setPageNumber,
}: any) => {
  const query = useQuery();
  const { t } = useTranslation();
  const { token, selectedStore } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState(query.get('searchId') || '');
  const [searchBy, setSearchBy] = useState<string>(
    query.get('searchBy') || 'orderId'
  );
  const [dateFrom, setDateFrom] = useState(
    query.get('dateFrom') || moment().subtract(2, 'years').format('YYYY-MM-DD')
  );
  const [dateTo, setDateTo] = useState(
    query.get('dateTo') || moment().format('YYYY-MM-DD')
  );

  const [filterStatus, setFilterStatus] = useState(
    query?.get('filterStatus') || 'ALL'
  );
  const [filterParams, setFilterParams] = useState({});
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [dateToError, setDateToError] = useState('');
  const [dateFromError, setDateFromError] = useState('');
  const numericInput = /^[0-9]+$/;
  const [reset, setReset] = useState(0);
  const [enterBtn, setEnterBtn] = useState(false);

  const getOrdersApi = (resetPageNumber = true) => {
    if (resetPageNumber && pageNumber.toString() !== '0') {
      setPageNumber('0');
      return;
    }
    setLoading(true);
    const params: any = {
      page: pageNumber,
      size: pageSize,
      storeId: selectedStore > 0 ? selectedStore : null,
      dateFrom,
      dateTo,
      ...processOrderStatus({ status: filterStatus }),
    };
    if (searchId && searchBy) {
      params[searchBy] = searchId.slice(0, 19);
    }
    setFilterParams(params);
    api
      .get({
        endpoint: 'orders/mashreq/neo-loan',
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((resp: any) => {
        setLoading(false);
        setRecords(resp.totalCount);
        const dataList = resp.data.map((item: any) => ({
          ...item,
          status: getFormattedOrderStatus({ item }),
          date: item.purchaseDate,
          merchantOrderCode: item.orderReference,
        }));
        setList(dataList);
      })
      .catch((resp: any) => {
        setLoading(false);
        api.errorHandler({
          resp,
          history,
          dispatch,
          callback: () => {
            dispatch({
              type: 'OPEN_TOASTER',
              payload: {
                toasterTitle: 'Fetch orders',
                toasterMessage: 'Error fetching orders',
                toasterType: 'error',
                toasterVisible: true,
              },
            });
          },
        });
      });
  };

  useEffect(() => {
    setPageNumber(0);
  }, [reset]);

  useEffect(() => {
    setLoading(true);
    const timeOut = setTimeout(() => {
      getOrdersApi(false);
    }, 500);
    return () => clearTimeout(timeOut);
  }, [
    filterStatus,
    selectedStore,
    dateFrom,
    dateTo,
    pageNumber,
    pageSize,
    enterBtn,
  ]);

  useEffect(() => {
    const pushTo = `searchBy=${searchBy}&searchId=${searchId}&dateFrom=${dateFrom}&dateTo=${dateTo}&filterStatus=${filterStatus}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    history.push(`?${pushTo}`);
  }, [
    filterStatus,
    selectedStore,
    dateFrom,
    dateTo,
    searchId,
    searchBy,
    pageSize,
    pageNumber,
  ]);
  useEffect(() => {
    setPageNumber(query.get('pageNumber') || '0');
  }, []);

  const getExcelReport = () => {
    api
      .get({
        endpoint: 'orders/mashreq/neo-loan/excel',
        responseType: 'blob',
        params: { ...filterParams },
        headers: {
          Authorization: token,
        },
      })
      .then((response: any) => {
        const [firstDate, secondDate] = new Date()
          .toLocaleString('no-nb')
          .split(',');
        const name = [
          ...firstDate.split('/'),
          ...secondDate.trim().split(':'),
        ].join('-');
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        const blob = response;
        const a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `Neo_Loan_report_${name}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  useEnterListener(() => setEnterBtn((prev) => !prev));

  const handleSelectChange = (selectedKey: string) => {
    setSearchId('');
    setSearchBy(selectedKey);
  };

  const handleSelectFilterChange = (selectedKey: string) => {
    setFilterStatus(selectedKey);
  };
  return (
    <>
      <div className="filters">
        <div className="filter-group">
          <div className="filter-input">
            <SelectComponent
              label="Search by"
              data={searchByData}
              selected={searchBy}
              onSelect={handleSelectChange}
            />
          </div>
          <div className="filter-input">
            <Input
              name="orderId"
              value={searchId}
              type="text"
              maxLength={searchBy === 'orderId' ? 14 : 100}
              onChange={(e: any) => {
                const searchValue = e.target.value;
                if (searchBy === 'orderId' || searchBy === 'merchantId') {
                  if (searchValue.match(numericInput) || searchValue === '') {
                    setSearchId(searchValue);
                  }
                } else {
                  setSearchId(searchValue);
                }
              }}
            />
          </div>
          <div className="filter-input">
            <Button
              extraClass="btn blue"
              onClick={() => {
                setReset(reset + 1);
                getOrdersApi();
              }}
            >
              Search
            </Button>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input">
            <label>From</label>
            <Input
              name="dateFrom"
              value={dateFrom}
              error={dateFromError ? ' ' : ''}
              type="date"
              onChange={(e: any) => {
                setDateToError('');
                setDateFrom(moment(e.currentTarget.value).format('YYYY-MM-DD'));
                setReset(reset + 1);
                if (moment(e.currentTarget.value).isAfter(dateTo) && dateTo) {
                  setDateFromError(t('validation-less'));
                } else {
                  setDateFromError('');
                }
              }}
            />
            <span className="error-message">{dateFromError}</span>
          </div>
          <div className="filter-input">
            <span>To</span>
            <Input
              name="dateTo"
              value={dateTo}
              type="date"
              error={dateToError ? ' ' : ''}
              onChange={(e: any) => {
                setDateFromError('');
                setDateTo(moment(e.currentTarget.value).format('YYYY-MM-DD'));
                setReset(reset + 1);
                if (
                  moment(e.currentTarget.value).isBefore(dateFrom) &&
                  dateFrom
                ) {
                  setDateToError(t('validation-greater'));
                } else {
                  setDateToError('');
                }
              }}
            />
            <span className="error-message">{dateToError}</span>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input status-dropdown">
            <SelectComponent
              label="Status"
              data={filterStatusDataArray}
              selected={filterStatus}
              onSelect={handleSelectFilterChange}
            />
          </div>

          <div className="filter-input">
            <Button
              extraClass={records ? 'btn blue' : ''}
              disabled={!records}
              onClick={() => setShowCancelModal(true)}
            >
              Export to Excel
            </Button>
          </div>
        </div>
      </div>
      <ExportModal
        showConfirmModal={showCancelModal}
        setShowConfirmModal={setShowCancelModal}
        token={token}
        history={history}
        dispatch={dispatch}
        getExcelReport={getExcelReport}
        records={records}
      />
    </>
  );
};
